(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest(
      '.product-grid-container add-to-cart-component .button, .product-grid-container .quick-add .button, .product-grid-container button[name="add"]'
    );

    if (!button) return;

    button.classList.remove('is-added');
    button.classList.add('is-adding');

    setTimeout(function() {
      button.classList.remove('is-adding');
      button.classList.add('is-added');

      setTimeout(function() {
        button.classList.remove('is-added');
      }, 500);
    }, 350);
  });

  } catch(e) { console.error(e); }
})();
})();
